function t(t) {
  var e = typeof t;
  return "function" === e || "object" === e && !!t;
}
export { t as default };